import React, { useEffect, useState, Fragment } from 'react';
import { Pagination, PageHeader, paginate } from '../../../Common';
import { TableContent} from '../../Common/Table/tableContent';
import { Fields, validateProperty, validate, Card } from "../../Common";
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import services from '../services';
import { search, SearchFeild } from '../../Common';
import MenuItem from '@material-ui/core/MenuItem';
import $ from 'jquery';
import { bplMasterDataSyncSchemaObject } from '../bplMasterDataSyncSchema';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';

import Joi from '@hapi/joi'
import { TextField } from '@material-ui/core';
import FileBase64 from 'react-file-base64';
import FormHelperText from '@material-ui/core/FormHelperText';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';

const screenCode = 'BPLMASTERDATASYNC'
const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    dialog1: {
        width: 850,
    }
});

export function Listing(props) {
    const classes = useStyles();
    const [data, setData] = useState([]);
    const [searchData, setSearchData] = useState({
        groupID: 0,
        operationEntityID: 0,
        masterDataTypeID: 0,
        syncedDate: ''

    });
    const [groups, setGroups] = useState()
    const [estates, setEstates] = useState()
    const [bplMasterDataTypes, setBPLMasterDataTypes] = useState()
    const [isTableHide, setIsTableHide] = useState(true);
    const [errors, setErrors] = useState({});
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(0);
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const schema = Joi.object(bplMasterDataSyncSchemaObject).options({ allowUnknown: true });
    const handleLimitChange = (event) => {
        setLimit(event.target.value);
    };

    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    useEffect(() => {
        getPermissions();
        getBPLMasterDataTypes();
    }, []);

    useEffect(() => {
        trackPromise(
            getEstates()
        )
    }, [searchData.groupID])

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWBPLMASTERDATASYNC');
        if(isAuthorized === undefined){
            props.history.push('/unauthorized');
        }

        var isAddEditEnabled = permissions.find(p => p.permissionCode == 'ADDEDITBPLMASTERDATASYNC');
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isAddEditEnabled: isAddEditEnabled !== undefined,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !==undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setSearchData({
            ...searchData,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });
        getAllGroups();
    }

    async function getEstates(){
        var data = await services.getEstatesByGroupID(searchData.groupID);
        setEstates(data)
    }

    async function getAllGroups() {
        const result = await services.getGroups()
        setGroups(result)
    }

    async function getBPLMasterDataTypes() {
        const result = await services.getBPLMasterDataTypes()
        setBPLMasterDataTypes(result)
    }

    function generateDropDownMenu(data) {

        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }
    async function handleSearch() {
            var model = {
                operationEntityID : parseInt(searchData.operationEntityID),
                masterDataTypeID : parseInt(searchData.masterDataTypeID),
                syncedDate : searchData.syncedDate == "" ? null : searchData.syncedDate
            };
            const data = await services.getSyncedData(model);
            if(data.length > 0) {
                setIsTableHide(false);
            }
            setData(data);
    }

    function handleGroupChange(target){
        validateInputs(target);

        setSearchData({
            ...searchData,
            groupID: target.value,
            operationEntityID: '0',
            collectionPointID:'0'
        })
    }

    function handleEstateChange(target){
        validateInputs(target);
        setSearchData({
            ...searchData,
            operationEntityID: target.value,
            collectionPointID:'0'
        })
    }

    function handleMasterDataTypeChange(target) {
        setSearchData({
            ...searchData,
            masterDataTypeID: target.value
        })
    }

    function handleSearchDateChange(target) {
        setSearchData({
            ...searchData,
            syncedDate: target.value

        });
    }
    
    function validateInputs(target){
        const error = {...errors};
        const errorMessage = validateProperty(target, bplMasterDataSyncSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setErrors(error)
        
    }

    function clearState() {
        var token = tokenService.getUserDetailsFromToken();
        setSearchData({
            ...searchData,
            groupID: !permissionList.isGroupFilterEnabled ? '0' : token.groupID,
            operationEntityID: !permissionList.isOperationEntityFilterEnabled ? '0' : token.operationEntityID,
            masterDataTypeID: '0',
            syncedDate: ''
        });
        setData([]);
        setIsTableHide(true);
    }

    function onCancelClick() {
        setErrors({});
        clearState();
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title="BPL Master Data Synchronization"
                                    isButtonEnable={permissionList.isAddEditEnabled}
                                    buttonText="Sync Master Data"
                                    path="bplMasterDataSync/addEdit" />
                            </div>
                            <hr />

                            <form onSubmit={(e) => trackPromise( handleSearch(e))}>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            name="groupID"
                                            value={searchData.groupID}
                                            onChange={(e) => handleGroupChange(e.target)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Estate *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="operationEntityID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            name="operationEntityID"
                                            value={searchData.operationEntityID}
                                            onChange={(e) => handleEstateChange(e.target)}>
                                            
                                            <MenuItem value="0">--Select Estate--</MenuItem>
                                            {generateDropDownMenu(estates)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="masterDataTypeID">Master Data Type</InputLabel>
                                        <Select
                                            fullWidth
                                            id="masterDataTypeID"
                                            name="masterDataTypeID"
                                            value={searchData.masterDataTypeID}
                                            onChange={(e) => handleMasterDataTypeChange(e.target)}>
                                            <MenuItem value="0">--Select Master Data Type--</MenuItem>
                                            {generateDropDownMenu(bplMasterDataTypes)}
                                        </Select>
                                    </div>

                                    <div className="col-md-4">
                                        <InputLabel shrink id="syncedDate">Date</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="syncedDate"
                                            name="syncedDate"
                                            type="date"
                                            onChange={(e) => handleSearchDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                </div>
                                <div className="card-footer">
                                    <input

                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={(e) => trackPromise(handleSearch(e))}
                                    />
                                    <input
                                        type="button"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />

                                </div>

                            </form>

                            <div className="table-responsive row-top-gap" >
                            {data.length > 0 ?
                                <div>
                                    <TableContainer component={Paper}>
                                        <Table className={classes.table} aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align="left" style={{ fontWeight: "bold" }}>Date</TableCell>
                                                    <TableCell align="left" style={{ fontWeight: "bold" }}>Time</TableCell>
                                                    <TableCell align="left" style={{ fontWeight: "bold" }}>Master Data Type</TableCell>
                                                    <TableCell align="left" style={{ fontWeight: "bold" }}>Estate Code</TableCell>
                                                    <TableCell align="left" style={{ fontWeight: "bold" }}>Estate Name</TableCell>
                                                    <TableCell align="left" style={{ fontWeight: "bold" }}>Synced By</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {data.slice(page * limit, page * limit + limit).map((row, i) => (
                                                    <TableRow key={i}>
                                                        <TableCell component="th" scope="row" align="left"> {moment(row.syncedDate).format('MM/DD/YYYY')}</TableCell>
                                                        <TableCell component="th" scope="row" align="left"> {moment(row.syncedDate).format('hh:mm A')}</TableCell>
                                                        <TableCell component="th" scope="row" align="left"> {row.masterDataTypeName}</TableCell>
                                                        <TableCell component="th" scope="row" align="left"> {row.bplEstateID}</TableCell>
                                                        <TableCell component="th" scope="row" align="left"> {row.operationEntityName}</TableCell>
                                                        <TableCell component="th" scope="row" align="left"> {row.firstName}</TableCell>
                                                    </TableRow>
                                                )
                                                )}

                                            </TableBody>
                                        </Table>
                                        <TablePagination
                                            component="div"
                                            count={data.length}
                                            onChangePage={handlePageChange}
                                            onChangeRowsPerPage={handleLimitChange}
                                            page={page}
                                            rowsPerPage={limit}
                                            rowsPerPageOptions={[5, 10, 25]}
                                        />
                                    </TableContainer>
                                </div>
                           : null }
                        </div>

                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )  
}